import * as $ from "jquery";
declare const TimelineLite: any;

export default class Parallax {
	timelines: any[];

	constructor() {
		this.timelines = [];

		this.initElements();
	}

	initElements() {
		$('[data-parallax]').each((i, element) => {
			element.setAttribute("data-parallax-timeline", i.toString());

			const tl = new TimelineLite();

			tl.fromTo(element, 10, {
				backgroundPositionY: "70%",
			}, {
				backgroundPositionY: "30%",
			}).pause();

			this.timelines.push(tl);
		});
	}

	scrollUpdate(lastPosition: number) {
		const checkBottom = lastPosition + $(window).innerHeight();
		$('[data-parallax]').each((i, element) => {
			const percent = this.calcPercent(<HTMLElement>element, checkBottom);
			const tlIndex = element.getAttribute("data-parallax-timeline");
			this.timelines[tlIndex].progress(percent / 100);
		});
	}

	calcPercent(element:HTMLElement, checkBottom:number) {
		const elTop = $(element).offset().top;
		const elCenter = $(element).height() / 2;
		const elBottom = elTop + $(element).outerHeight() + $(window).innerHeight();

		const checkPoint = elTop + elCenter;
		const onScreen = (elTop <= checkBottom && checkBottom <= elBottom) ? true : false;
		
		let distanceFromBottom = checkBottom - checkPoint;
		let travelPercent = ((distanceFromBottom / $(window).innerHeight()) * 100);
		if (travelPercent > 100) {
			travelPercent = 100;
		} else if (travelPercent < 0) {
			travelPercent = 0;
		}

		return parseInt(travelPercent.toString());
	}
}